import EmbedMode from "discourse/lib/embed-mode";
import { withPluginApi } from "discourse/lib/plugin-api";
import ModMarketContextualBanner from "../components/mod-market-contextual-banner";

export default {
  name: "discourse-mod-market-contextual-banner",

  initialize(container) {
    const siteSettings = container.lookup("service:site-settings");
    if (!siteSettings.discourse_mod_market_enabled || EmbedMode.enabled) {
      return;
    }

    withPluginApi((api) => {
      api.renderInOutlet("community-home-banner", ModMarketContextualBanner);
      api.renderInOutlet("community-game-banner", ModMarketContextualBanner);
    });
  },
};
